import React, { useState } from "react";
import Title from "antd/es/typography/Title";
import {
  AuthResult,
  AzureBlobResponse,
} from "../../../../../../../shared/file-upload/azure-upload";
import { FileInfo } from "../../../../../../../../generated";
import { FilePreview } from "../../../../../../../shared/file-preview/file-preview";
import { FileUploadButton } from "../../../../../../../shared/file-upload/file-upload-button";

interface FileUploadProps {
  title: string;
  description: string;
  buttonText: string;
  fileData: FileInfo;
  permittedContentTypes: string[];
  permittedExtensions: string[];
  assetUpdateFunction: (file: File) => Promise<AuthResult>;
  fetchFileData: () => void;
  onSuccess: (response: AzureBlobResponse) => Promise<void>;
  previewOnly?: boolean;
  setIsEditing?: React.Dispatch<React.SetStateAction<boolean>>;
  uploadPreviewImage?: boolean;
  isShowFileName?: boolean;
}

export const FileUpload: React.FC<FileUploadProps> = ({
  previewOnly = false,
  uploadPreviewImage: uploadImage = true,
  ...props
}) => {
  const [refresh, setRefresh] = useState(0);

  return (
    <div
      style={{
        maxWidth: "50%",
        fontSize: "10px",
        margin: "10px",
      }}
    >
      <Title level={5}>{props.title}</Title>
      <div
        style={{
          marginBottom: "10px",
        }}
      >
        {props.description}
      </div>
      <FilePreview
        key={refresh}
        fileUrl={props.fileData?.url}
        fileName={props.fileData?.name.split("/").pop() ?? ""}
        fileType={props.fileData?.type ?? ""}
        isShowFileName={props.isShowFileName}
      />
      <br></br>
      <br></br>
      {!previewOnly && (
        <FileUploadButton
          authorizeRequest={props.assetUpdateFunction}
          buttonText={props.buttonText}
          maxFileCount={1}
          permittedContentTypes={props.permittedContentTypes}
          permittedExtensions={props.permittedExtensions}
          maxFileSizeBytes={10 * 1024 * 1024} // 10MB,
          maxWidthOrHeight={2048}
          onSuccess={async (response) => {
            props.onSuccess(response);
            // props.fetchFileData();
            setRefresh((prev) => prev + 1);
            if (props.setIsEditing) {
              props.setIsEditing(!previewOnly);
            }
          }}
          uploadImage={uploadImage}
        />
      )}
    </div>
  );
};
